import React from 'react'
import {ProfileItem} from './profileItem'
export const Profiles = () => {
    const [profiles] = React.useState([
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        },
        {
            name:'Something',
            sector:[{   title:'Agriculture', }],
            city:[{   name:'Cairo', }],
        }
    ])
    return (
        <div className="profiles">
            <ul>
                {
                    profiles?.length > 0 && profiles.map((item,i)=>(
                        <ProfileItem item={item} key={'profiles'+i} />
                    ))
                }
            </ul>

        </div>
    )

}
 